export enum COMPONENT_STATE {
    BASE = 'base',
    HOVER = 'hover'
}

export enum STYLE_ATTRIBUTE {
    TEXT = 'text',
    BACKGROUND = 'background',
    BORDER = 'border'
}

export enum POPUP_LAYOUT {
    FULLSCREEN = 'fullscreen',
    MODAL = 'modal'
}

export enum CLOSE_BUTTON_POSITION {
    LEFT = 'left',
    RIGHT = 'right'
}

export enum CLOSE_BUTTON_SIZE {
    XS = 'xs',
    SM = 'sm',
    MD = 'md',
    LG = 'lg'
}

export enum MODAL_TYPE {
    POPUP = 'popup',
    TEASER = 'teaser'
}
